import React from 'react';
import { bgColors } from '../../../glassConsts';
import { useConfig } from '../../ConfigContext';

export default function ColorPicker() {
  const { general, setGeneralState } = useConfig();

  return (
    <div className="color-select">
      <div>
        <label className="custom-label">Barva šablony</label>
        <div className="flex gap-2 mt-1">
          {bgColors.map((c) => (
            <button
              key={c.code}
              className={`w-7 h-7 rounded-full ${
                general.bg === c.code ? 'border-black' : 'border-gray-300'
              }`}
              style={{
                background: c.code,
                borderWidth: '1px',
                borderColor: '#bcbcbc',
              }}
              onClick={() => setGeneralState({ color: c.code })}
              type="button"
            />
          ))}
        </div>
      </div>
      <div>
        <label className="custom-label cursor-pointer">
          <span className="">Vlastní:</span>
        </label>
        <span className="w-8 h-8 rounded border border-gray-300 shadow flex items-center justify-center">
          <input
            type="color"
            className="w-8 h-8 opacity-0 absolute cursor-pointer"
            value={general.color}
            style={{
              zIndex: 9999,
            }}
            onChange={(e) => setGeneralState({ color: e.target.value })}
          />
          <span
            className="absolute w-6 h-6 rounded"
            id="color-preview"
            style={{ background: general.color }}
          ></span>
        </span>
      </div>
    </div>
  );
}
